export const ANDROID_PLATFORM_OS = "android";
export const IOS_PLATFORM_OS = "ios";

export type MobileApplicationPlatform = typeof ANDROID_PLATFORM_OS | typeof IOS_PLATFORM_OS;
